import * as apiUtils from "@/utils/apiUtils"

export default {
  namespaced: true,
  // -----------------------------------------------------------------
  state: {
    accountings: []
  },
  // -----------------------------------------------------------------
  getters: {
    accountings: state => {
      return state.accountings
    }
  },
  // -----------------------------------------------------------------
  mutations: {
    setAccoutings: (state, accountings) => {
      state.accountings = accountings
    }
  },
  // -----------------------------------------------------------------
  actions: {
    getCategories: context => {
      var bid = context.rootGetters["bizes/bid"]()
      var path = "/bizes/" + bid + "/accounting/account-categories"
      return apiUtils.get(path)
    },
    getAccount: (context, id) => {
      var bid = context.rootGetters["bizes/bid"]()
      var path = "/bizes/" + bid + "/accounting/accounts/" + id
      return apiUtils.get(path)
    },
    getAccounts: context => {
      var bid = context.rootGetters["bizes/bid"]()
      if (bid != null) {
        var path = "/bizes/" + bid + "/accounting/accounts"
        return apiUtils.get(path)
      } else {
        return {}
      }
    },
    setAccounts: (context, accountings) => {
      context.commit("setAccoutings", accountings)
    },
    getAccountsByCategory: (context, category) => {
      var bid = context.rootGetters["bizes/bid"]()
      var path = "/bizes/" + bid + "/accounting/accounts/query?category=" + category
      return apiUtils.get(path)
    },
    getAccountsByGroup: (context, group) => {
      var bid = context.rootGetters["bizes/bid"]()
      var path = "/bizes/" + bid + "/accounting/accounts/query?group=" + group
      return apiUtils.get(path)
    },
    createAccount: (context, { category, name, description }) => {
      var bid = context.rootGetters["bizes/bid"]()
      var path = "/bizes/" + bid + "/accounting/accounts"
      return apiUtils.post(path, { category, name, description })
    },
    updateAccount: (context, { id, category, name, description, isArchived, isEditable }) => {
      var bid = context.rootGetters["bizes/bid"]()
      var path = "/bizes/" + bid + "/accounting/accounts/" + id
      return apiUtils.patch(path, {
        category,
        name,
        description,
        isArchived,
        isEditable
      })
    },
    deleteAccount: (context, id) => {
      var bid = context.rootGetters["bizes/bid"]()
      var path = "/bizes/" + bid + "/accounting/accounts/" + id
      return apiUtils.delete(path)
    }
  }
}
